import { useEffect, useState } from "react";
import { DateTime } from "luxon";

import {
  DateElementProps,
  DateRangeElementProps,
  DateRangeProcessedData,
} from "./types";

export const DateElement = ({
  value,
  format = "dd-MM-yyyy",
}: DateElementProps) => {
  if (!value) {
    return null;
  }
  if (!DateTime.isDateTime(value)) {
    value = DateTime.fromISO(value);
  }

  return <div>{value.toFormat(format)}</div>;
};

export const DateRangeElement = ({
  value,
  format = "dd-MM-yyyy",
}: DateRangeElementProps) => {
  const [processedValue, setProcessedValue] = useState<DateRangeProcessedData>({
    startDate: null,
    endDate: null,
  });

  useEffect(() => {
    if (!value) return;
    const start = value[0];
    const end = value[1];
    setProcessedValue({
      startDate: start ? DateTime.fromISO(start) : null,
      endDate: end ? DateTime.fromISO(end) : null,
    });
  }, [value]);

  if (!processedValue.startDate && !processedValue.endDate)
    return <div>N/A</div>;

  return (
    <div>
      {processedValue.startDate
        ? processedValue.startDate.toFormat(format)
        : "N/A"}{" "}
      -{" "}
      {processedValue.endDate ? processedValue.endDate.toFormat(format) : "N/A"}
    </div>
  );
};
